import * as React from 'react';
import { cn } from '@src/design-system/helpers';

const TableRow = React.forwardRef<
  HTMLTableRowElement,
  React.HTMLAttributes<HTMLTableRowElement>
>(({ className, ...props }, ref) => (
  <tr
    ref={ref}
    className={cn(
      'transition-colors hover:bg-muted/50 data-[state=selected]:bg-primary-100',
      className
    )}
    {...props}
  />
));

TableRow.displayName = 'TableRow';

export default TableRow;
